module.exports = __webpack_public_path__ + "static/media/wtr-logo.2560de6c.png";